// src/services/apiService.js

import axios from 'axios';

const API_URL = process.env.VUE_APP_API_ROOT_ENDPOINT;

// Create a general Axios instance that will be reused across other services
const axiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 10000, // Set a reasonable timeout for requests (e.g., 10 seconds)
    headers: {
        'Content-Type': 'application/json',
    },
});

// Attach token to every request if it exists, except for anonymous requests to /api/auth
axiosInstance.interceptors.request.use(async (config) => {
    const token = localStorage.getItem('token');
    const isAnonymousRequest = config.url.startsWith('/auth');
    if (token && !isAnonymousRequest) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle responses and errors globally
axiosInstance.interceptors.response.use(
    async (response) => {
        return response;
    },
    async (error) => {
        // Handle errors globally, e.g., redirect to login if unauthorized
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login'; // Redirect to login page if not authorized
        }
        throw error;
    }
);

export default axiosInstance;
